import styled from "styled-components";

export const Wrapper = styled.div`

border: 1px solid #CCC;
border-radius: 10px;
margin:16px 16px;
padding: 8px;
width:250px;
height: 150px;
align-content: center;
line-height: 30px;


h2{
    display: block; 
    color: grey;
    overflow: hidden;
    text-overflow: ellipsis;
   font-weight: bold;
   white-space: nowrap;

}
a{
    display: block; 
    white-space: nowrap;
    color: purple;
    overflow: hidden;
    text-overflow: ellipsis;
   
}

`